
$(document).ready(function () {
  const $comparison = $(".product-comparison");
  if (!$comparison.length) return;

  const $layout = $comparison.find(".comparison-layout");
  const $toggle = $comparison.find(".comparison-toggle");
  const $toggleText = $toggle.find("span").first();

  const totalSpecs = $comparison.find(
    ".comparison-labels .spec-label"
  ).length;

  const visibleSpecs = 10;

  function extraSpaceAdjustment() {
    let maxHeadingHeight = 0;

    $comparison.find(".product-heading").each(function () {
      maxHeadingHeight = Math.max(
        maxHeadingHeight,
        $(this).outerHeight() || 0
      );
    });

    // $comparison.find(".comparison-label-spacer").css(
    //   "flex-basis",
    //   maxHeadingHeight + "px"
    // );
    
    var $sectionHeading = $(".comparison-products-scroll .section-heading-wrap");

    if ($sectionHeading.length) {
      var sectionHeading = $sectionHeading.outerHeight();

      $comparison.find(".comparison-label-spacer").css(
        "flex-basis",
        maxHeadingHeight + sectionHeading + "px"
      );
    } else {
      $comparison.find(".comparison-label-spacer").css(
        "flex-basis",
        maxHeadingHeight + "px"
      );
    }

  }

  function updateComparisonView() {
    const isExpanded = $toggle.attr("aria-expanded") === "true";

    $layout.toggleClass("show-all", isExpanded);

    $toggleText.text(
      isExpanded
        ? "Show fewer specifications"
        : "Show all " + totalSpecs + " specifications"
    );

  }

  $toggle.on("click", function () {
    const isExpanded =
      $(this).attr("aria-expanded") !== "true";

    $(this).attr("aria-expanded", String(isExpanded));

    updateComparisonView();
  });

  // Horizontal drag scrolling
  $comparison.find(".comparison-products-scroll").each(function () {
    const scroller = this;

    let isDragging = false;
    let startX = 0;
    let initialScrollLeft = 0;
    let hasMoved = false;

    $(scroller).on("mousedown", function (event) {
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      if (event.which !== 1) return;

      isDragging = true;
      hasMoved = false;
      startX = event.pageX;
      initialScrollLeft = scroller.scrollLeft;

      $(scroller).addClass("is-dragging");
    });

    $(document).on("mousemove.comparisonDrag", function (event) {
      if (!isDragging) return;

      const distance = event.pageX - startX;

      if (Math.abs(distance) > 3) {
        hasMoved = true;
      }

      if (hasMoved) {
        event.preventDefault();
        scroller.scrollLeft = initialScrollLeft - distance;
      }
    });

    $(document).on("mouseup.comparisonDrag", function () {
      isDragging = false;
      $(scroller).removeClass("is-dragging");
    });

    $(scroller).on("click", function (event) {
      if (hasMoved) {
        event.preventDefault();
        event.stopPropagation();
        hasMoved = false;
      }
    });
  });

  // Product color swatches
  $comparison.find(".product-swatches").each(function () {
    const $swatches = $(this).find(".swatch");

    $swatches.on("click", function () {
      $swatches
        .removeClass("active")
        .attr("aria-pressed", "false");

      $(this)
        .addClass("active")
        .attr("aria-pressed", "true");
    });
  });

  // Start collapsed on every viewport.
  $toggle.attr("aria-expanded", "false");

  extraSpaceAdjustment();
  updateComparisonView();

  let resizeTimer;

  $(window).on("resize.productComparison", function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      extraSpaceAdjustment();
    }, 100);
  });
});
